import React from 'react';
import styles from './EltyInfoButton.module.css';
export const EltyInfoButton = () => {
  const [showMenu, setShowMenu] = React.useState(false);
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [showMenu]);

  return (
    <div className={styles.container} ref={containerRef}>
      <button
        className={styles.infoButton}
        onClick={() => setShowMenu(true)}
        aria-label="Show Elty Salute information"
        aria-expanded={showMenu}
        aria-haspopup="true"
      >
        + INFO
      </button>
      {showMenu && (
        <div className={styles.infoMenu}>
          <div className={styles.menuContent}>
            <h3>Cos'è Elty Salute?</h3>
            <p>
              Un servizio di telemedicina che ti permette di consultare medici
              specialisti online, quando e dove vuoi.
            </p>
            <strong>Cosa include:</strong>
            <ul>
              <li>Consulenze mediche online 24/7</li>
              <li>Accesso a medici specialisti certificati</li>
              <li>Ricette e certificati medici digitali</li>
              <li>Gestione digitale delle cartelle cliniche</li>
            </ul>
            <div className={styles.divider} />

            <div className={styles.footer}>
              <strong>Offerta speciale:</strong> Gratuito per i primi 6 mesi.
              Dopo il periodo promozionale, 9.99 €/mese. <br />
              Disdici quando vuoi senza vincoli.
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
